<script>
  //  import { auth, db } from "../../etc/firebase.js"
  //import { yaoCountMap } from "../../etc/store.js"
  import { onMount } from "svelte"

  import { sim_results } from "./simResults.js"
  import { gua64 } from "./gua64.js"
  import * as d3 from "d3"
  //var data = [130, 86, 168, 281, 303, 365]

  let el

  onMount(() => {
    let yaoList = []
    let yaoKey = ["6", "7", "8", "9"]
    let yaoTotal = 0
    for (var i = 0; i < yaoCountMap.size; i++) {
      yaoList.push(yaoCountMap.get(yaoKey[i]))
      yaoTotal = yaoTotal + yaoCountMap.get(yaoKey[i])
    }
    d3.select(el)
      .selectAll("div")
      //   .data(data)
      .data(yaoList)
      .enter()
      .append("div")
      .style("width", function (d) {
        return (200 * d) / yaoTotal + "%"
        // return d + "px"
      })
      .text(function (d) {
        return d
      })
  })

  // Get value from Map
  function getMapValue(value, key, map) {
    return value
  }
  // Build Gua count map
  const guaCountMap = new Map()

  // initialize the map
  for (var i = 0; i < gua64.length; i++) {
    guaCountMap.set(gua64[i].code, 0)
  }

  //   console.log(guaCountMap.get("111111"))
  //   let junk = 88
  //   guaCountMap.set("111111", ++junk)
  //   console.log(guaCountMap.get("111111"))

  // get Gua Result
  let cloudGuaResults = []
  let simCount = 0

  let count6ideal = 100 * (1 / 16)
  let count7ideal = 100 * (5 / 16)
  let count8ideal = 100 * (7 / 16)
  let count9ideal = 100 * (3 / 16)
  let count6stat = 0
  let count7stat = 0
  let count8stat = 0
  let count9stat = 0
  let count6diff = 0
  let count7diff = 0
  let count8diff = 0
  let count9diff = 0

  function number2code(numStr) {
    // numStr is a 6-char long string consists of [6, 7, 8, 9]
    // 6, 8 --> 0
    // 7, 9 --> 1

    let codeStr = ""
    for (let i = 0; i < numStr.length; i++) {
      if (numStr[i] % 2 == 0) {
        codeStr = codeStr + "0"
      } else {
        codeStr = codeStr + "1"
      }
    }
    return codeStr
  }

  simCount = sim_results.length
  //console.log("Gua Count = " + simCount)

  //console.log("sim_results[0] = " + sim_results[0])
  let runCount = simCount
  //let runCount = 50000

  let yaoTitleMap = new Map()
  yaoTitleMap.set("6", "老陰")
  yaoTitleMap.set("7", "少陽")
  yaoTitleMap.set("8", "少陰")
  yaoTitleMap.set("9", "老陽")
  let yaoCountMap = new Map()
  yaoCountMap.set("6", 0)
  yaoCountMap.set("7", 0)
  yaoCountMap.set("8", 0)
  yaoCountMap.set("9", 0)
  let yaoStatMap = new Map()
  let yaoIdealMap = new Map()
  yaoIdealMap.set("6", 1 / 16)
  yaoIdealMap.set("7", 5 / 16)
  yaoIdealMap.set("8", 7 / 16)
  yaoIdealMap.set("9", 3 / 16)
  let yaoIdealStrMap = new Map()
  yaoIdealStrMap.set("6", "1/16")
  yaoIdealStrMap.set("7", "5/16")
  yaoIdealStrMap.set("8", "7/16")
  yaoIdealStrMap.set("9", "3/16")

  let yaoDiffMap = new Map()

  for (var i = 0; i < runCount; i++) {
    //for (var i = 0; i < 100; i++) {
    let tmpGua = sim_results[i].toString()
    //console.log(i + ", tmpGua: " + tmpGua)
    let tmpCode = number2code(tmpGua)
    //console.log(i + ", tmpCode: " + tmpCode)
    let tmpCounter = guaCountMap.get(tmpCode)
    //console.log(i + ", tmpCounter (before): " + tmpCounter)

    guaCountMap.set(tmpCode, ++tmpCounter)
    //console.log(i + ", tmpCounter (after): " + tmpCounter)

    //console.log(tmpGua[0])
    for (var j = 0; j < 6; j++) {
      if (tmpGua[j] == 6) {
        yaoCountMap.set("6", yaoCountMap.get("6") + 1)
      } else if (tmpGua[j] == 7) {
        yaoCountMap.set("7", yaoCountMap.get("7") + 1)
      } else if (tmpGua[j] == 8) {
        yaoCountMap.set("8", yaoCountMap.get("8") + 1)
      } else {
        yaoCountMap.set("9", yaoCountMap.get("9") + 1)
      }
    }
  }

  // Handle Yao stats
  let yaoList = ["6", "7", "8", "9"]
  let statList = [100 / 16, 500 / 16, 700 / 16, 300 / 16]
  for (var i = 0; i < 4; i++) {
    yaoStatMap.set(
      yaoList[i],
      100 * (yaoCountMap.get(yaoList[i]) / (runCount * 6))
    )
    yaoDiffMap.set(
      yaoList[i],
      (100 * (yaoStatMap.get(yaoList[i]) - 100 * yaoIdealMap.get(yaoList[i]))) /
        (100 * yaoIdealMap.get(yaoList[i]))
    )
  }
  count6stat = 100 * (yaoCountMap.get("6") / (runCount * 6))
  count7stat = 100 * (yaoCountMap.get("7") / (runCount * 6))
  count8stat = 100 * (yaoCountMap.get("8") / (runCount * 6))
  count9stat = 100 * (yaoCountMap.get("9") / (runCount * 6))

  //console.log(yaoDiffMap.get("6"))

  count6diff = (100 * (count6stat - count6ideal)) / count6ideal
  count7diff = (100 * (count7stat - count7ideal)) / count7ideal
  count8diff = (100 * (count8stat - count8ideal)) / count8ideal
  count9diff = (100 * (count9stat - count9ideal)) / count9ideal

  let mapGuaCount = 0
  let guaDiffRedline = 10
  let yaoDiffRedline = 5
  const simPercentage = new Map()
  const simDiff = new Map()
  const guaWarning = new Map()
  const idealGuaPercentage = 100 / 64 + "% (1/64)"
  let isWarning = false
  for (var i = 0; i < gua64.length; i++) {
    isWarning = false
    mapGuaCount = mapGuaCount + guaCountMap.get(gua64[i].code)
    simPercentage.set(
      gua64[i].code,
      (100 * guaCountMap.get(gua64[i].code)) / runCount
    )
    simDiff.set(
      gua64[i].code,
      (100 * (guaCountMap.get(gua64[i].code) / runCount - 1 / 64)) / (1 / 64)
    )
    if (Math.abs(simDiff.get(gua64[i].code)) > guaDiffRedline) {
      //console.log(i + ", " + Math.abs(simDiff.get(gua64[i].code)))
      guaWarning.set(gua64[i].code, true)
      //console.log(i + ", " + guaWarning.get(gua64[i].code))
      isWarning = true
    } else {
      guaWarning.set(gua64[i], false)
    }
  }

  //console.log(simPercentage.get(gua64[0].code))
</script>

<main>
  <a href="/sandbox">Return to Sandbox</a>

  <h5>XiYi Simulation Statistics</h5>
  <p><em>Total AutoQi Simulation Runs: <strong>{runCount}</strong></em></p>
  <p>
    This is for my current project XiYi - a site for helping I-Ching learner to
    practice. Target release: Q1/2021.
  </p>
  <p>
    AutoQi is part of the XiYi project feature. As of 2/18/2021, the AutoQi
    simulation statistics met my initial performance target as shown below. The
    AutoQi algorithm will continue to be fine tuned.
  </p>

  <h5>Yao Statistics (Goal: within {yaoDiffRedline}%)</h5>
  <table>
    <thead>
      <tr>
        <th>Title</th>
        <th>Code</th>
        <th>Count</th>
        <th>Simulation Percentage</th>
        <th>Ideal Percentage</th>
        <th>Difference</th>
      </tr>
    </thead>

    <tbody>
      <tr>
        <td>總卦數 - Simulation Runs</td>
        <td>6, 7, 8, 9</td>
        <td>{runCount}</td>
        <td>{(100 * runCount) / runCount}%</td>
        <td>100%</td>
        <td>0%</td>
      </tr>
      {#each yaoList as yao}
        <tr
          style={Math.abs(yaoDiffMap.get(yao)) > yaoDiffRedline
            ? "color: red;"
            : ""}
        >
          <td>{yaoTitleMap.get(yao)}</td>
          <td>{yao}</td>
          <td>{yaoCountMap.get(yao)}</td>
          <td
            >{Math.round((yaoStatMap.get(yao) + Number.EPSILON) * 100) /
              100}%</td
          >
          <td>{100 * yaoIdealMap.get(yao)}% ({yaoIdealStrMap.get(yao)})</td>
          <td
            >{Math.round((yaoDiffMap.get(yao) + Number.EPSILON) * 100) /
              100}%</td
          >
        </tr>
      {/each}
      <tr>
        <td>總爻數 - Yao Count</td>
        <td />
        <td
          >{yaoCountMap.get("6") +
            yaoCountMap.get("7") +
            yaoCountMap.get("8") +
            yaoCountMap.get("9")}</td
        >
      </tr>
    </tbody>
  </table>
  <br />
  <div class="container">
    <div bind:this={el} class="chart" />
  </div>
  <br />
  <h5>Gua Statistics (Goal: within {guaDiffRedline}%)</h5>
  <p>
    <strong>Expectation:</strong> As yin and yang distribution is 50% vs 50% by theorem.
    All the guas should be more or less evenly distributed.
  </p>
  <table>
    <thead>
      <tr>
        <th>Gua Name</th>
        <th>Code</th>
        <th>Count</th>
        <th>Simulation Percentage</th>
        <th>Ideal Percentage</th>
        <th>Difference</th>
      </tr>
    </thead>

    <tbody>
      {#each gua64 as gua}
        <tr style={guaWarning.get(gua.code) ? "color: red;" : ""}>
          <td>{gua.fullName}</td>
          <td>{gua.code}</td>
          <td>{guaCountMap.get(gua.code)}</td>
          <td>{simPercentage.get(gua.code)}%</td>
          <td>{idealGuaPercentage}</td>
          <td>{simDiff.get(gua.code)}%</td>
        </tr>
      {/each}
      <tr>
        <td><strong>Total Simulation Runs</strong></td>
        <td />
        <td><strong>{mapGuaCount}</strong></td>
      </tr>
    </tbody>
  </table>
</main>

<style>
  .chart :global(div) {
    width: 100%;
    font: 10px sans-serif;
    background-color: rgb(76, 94, 194);
    text-align: right;
    padding: 3px;
    margin: 5px;
    color: white;
  }
</style>
